import React, { useState } from 'react';
import { COLORS, SPACING } from '../styles/theme';
import { Modal } from './Modal';
import { Upload } from './Upload';
import { PostComposer } from './PostComposer';
import { EventComposer } from './EventComposer';
import { CommunityComposer } from './CommunityComposer';

const METAL_GRADIENT =
  'radial-gradient(circle at 32% 26%, rgba(255,255,255,0.14), rgba(255,255,255,0) 42%), ' +
  'linear-gradient(180deg, #5c5c58 0%, #3a3a38 36%, #232220 52%, #34322f 68%, #4a4844 100%)';
const METAL_SHADOW = 'inset 0 1px 1px rgba(255,255,255,0.18), inset 0 -2px 4px rgba(0,0,0,0.65), 0 3px 6px rgba(0,0,0,0.6)';
const METAL_SHADOW_PRESSED = 'inset 0 1px 1px rgba(255,255,255,0.1), inset 0 -1px 2px rgba(0,0,0,0.6), 0 1px 2px rgba(0,0,0,0.6)';

function CreateOption({ icon, label, onClick }: { icon: string; label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: SPACING.sm,
        padding: SPACING.xl,
        background: METAL_GRADIENT,
        border: '1px solid #0a0a09',
        boxShadow: METAL_SHADOW,
        color: COLORS.highlight,
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '11px',
        fontWeight: 700,
        cursor: 'pointer',
        transition: 'box-shadow 0.15s ease, transform 0.1s ease',
      }}
      onMouseDown={e => { e.currentTarget.style.boxShadow = METAL_SHADOW_PRESSED; e.currentTarget.style.transform = 'translateY(1px)'; }}
      onMouseUp={e => { e.currentTarget.style.boxShadow = METAL_SHADOW; e.currentTarget.style.transform = 'none'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = METAL_SHADOW; e.currentTarget.style.transform = 'none'; }}
    >
      <span style={{ fontSize: '26px', color: COLORS.text, filter: 'drop-shadow(0 1px 0 rgba(0,0,0,0.6))' }}>{icon}</span>
      <span style={{ letterSpacing: '0.06em' }}>{label}</span>
    </button>
  );
}

export function CreateSheet({ onClose, onCreated }: { onClose: () => void; onCreated: () => void }) {
  const [kind, setKind] = useState<'video' | 'post' | 'event' | 'community' | null>(null);

  if (kind === 'video') {
    return (
      <Modal title="new video" onClose={onClose}>
        <Upload defaultOpen />
      </Modal>
    );
  }
  if (kind === 'post') {
    return (
      <Modal title="new post" onClose={onClose}>
        <PostComposer onPosted={() => { onCreated(); onClose(); }} />
      </Modal>
    );
  }
  if (kind === 'event') {
    return (
      <Modal title="new event" onClose={onClose}>
        <EventComposer defaultOpen onPublished={() => { onCreated(); onClose(); }} />
      </Modal>
    );
  }
  if (kind === 'community') {
    return (
      <Modal title="new community" onClose={onClose}>
        <CommunityComposer onCreated={() => { onCreated(); onClose(); }} />
      </Modal>
    );
  }

  return (
    <Modal title="create" onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACING.lg, padding: SPACING.lg }}>
        <CreateOption icon="▶" label="video" onClick={() => setKind('video')} />
        <CreateOption icon="≡" label="post" onClick={() => setKind('post')} />
        <CreateOption icon="◆" label="event" onClick={() => setKind('event')} />
        <CreateOption icon="⬡" label="community" onClick={() => setKind('community')} />
      </div>
    </Modal>
  );
}
